module.exports = __webpack_public_path__ + "fa-light-300.01422b95c73840588205.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-light-300.eot
// module id = ../../../../../src/assets/fonts/webfonts/fa-light-300.eot
// module chunks = styles